module.exports = __webpack_public_path__ + "static/media/AutoSegmentationToolActive.ce5fb9e1.png";